import { useState } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Modal from '@mui/material/Modal';

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 PRO React examples
import FormField from "layouts/applications/wizard/components/FormField";
import DataTable from "examples/Tables/DataTable";
import { Autocomplete, CardContent, Typography, Tooltip, IconButton } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import GooglePlacesAutocomplete, { geocodeByPlaceId } from 'react-google-places-autocomplete';
import ModalItem from "cruds/modals/items/entity-address-item";
import { ToastContainer, toast } from 'react-toastify';
import 'material-react-toastify/dist/ReactToastify.css';

const CampaignAddress = ({ addresses, setAddresses }) => {

    const [newAddress, setNewAddress] = useState(Object.keys(addresses).length ? addresses : { primary_street_address1: "", primary_street_address2: "", primary_city: "", primary_state: "", primary_postal_code: "" });
    const [open, setOpen] = useState(false);
    const [indexAddr, setIndexAddr] = useState(0);
    const [handleMode, setHandleMode] = useState(false);

    const changeAddressHandler = (index, field, value) => {
        if (!handleMode) {
            setNewAddress((prevAddress) => ({
                ...prevAddress,
                [field]: value
            }));
        }

        if (handleMode) {
            setNewAddress((prevAddress) => ({
                ...prevAddress,
                [field]: value
            }));
        }
    };

    const handleSelect = async (value) => {
        try {
            const results = await geocodeByPlaceId(value.place_id);
            if (results && results.length > 0) {
                const placeData = results[0];
                const { address_components, formatted_address, geometry } = placeData;

                // Create a new address object with selected place information
                const newAddressObj = {
                    primary_street_address1: `${address_components.find(comp => comp.types.includes('street_number'))?.long_name || ""} ${address_components.find(comp => comp.types.includes('route'))?.long_name || ""}`,
                    primary_street_address2: address_components.find(comp => comp.types.includes('neighborhood'))?.long_name || "",
                    primary_city: address_components.find(comp => comp.types.includes('locality'))?.long_name || "",
                    primary_state: address_components.find(comp => comp.types.includes('administrative_area_level_1'))?.short_name || "",
                    primary_postal_code: address_components.find(comp => comp.types.includes('postal_code'))?.long_name || "",
                    // primary_country: address_components.find(comp => comp.types.includes('country'))?.long_name || "",
                };

                setNewAddress(newAddressObj);
                if (handleMode) {
                    // Update the address at the specified index for editing
                    const updatedAddresses = [...addresses];
                    updatedAddresses[indexAddr] = newAddressObj;
                    setAddresses(updatedAddresses);
                }
            }
        } catch (error) {
            console.error('Error fetching geolocation:', error);
        }
    };

    const notify = (text) => {
        if (!toast) {
            console.error('Toast object is undefined');
            return;
        }
        toast.warning(text, {
            position: 'top-right',
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
    }
    const addressHandler = () => {

        if (!handleMode) {
            const updatedNewAddress = {
                ...newAddress,
            };
            if (newAddress.primary_street_address1.trim() === '') {
                notify('Please set Street of Address!');
                return;
            }
            if (newAddress.primary_city.trim() === '') {
                notify('Please set city of Address!');
                return;
            }
            if (newAddress.primary_state.trim() === '') {
                notify('Please set State of Address!');
                return;
            }
            if (newAddress.primary_postal_code.trim() === '') {
                notify('Please set Postal Code of Address!');
                return;
            }
            // if (newAddress.primary_country.trim() === '') {
            //     notify('Please set Country of Address!');
            //     return;
            // }
            setAddresses(updatedNewAddress);
        } else {
            const updatedNewAddress = {
                ...newAddress
            };
            let updatedArresses = updatedNewAddress;
            // updatedArresses[indexAddr] = updatedNewAddress;
            setAddresses(updatedArresses);
        }
        // setAddresses([...addresses, { street_address1: "t", street_address2: "t", city: "t", state: "t", postal_code: "", country: "", latitude: "", longitude: "", address_type_id: "", status_type_id: "" }]);

        // setNewAddress({ street_address1: "", street_address2: "", city: "", state: "", postal_code: "", country: "", latitude: "", longitude: "", address_type_id: "", status_type_id: "", module: [] });
        setOpen(false);
    };

    const editAddress = (index) => {
        setIndexAddr(index);
        setHandleMode(true);
        const updatedAddresses = addresses;

        setNewAddress(updatedAddresses);

        setOpen(true);
    };

    const handleOpen = () => {
        setOpen(true);
        setHandleMode(false);
        setNewAddress({ primary_street_address1: "", primary_street_address2: "", primary_city: "", primary_state: "", primary_postal_code: "" });
        setIndexAddr(0);
    };

    const removeAddress = (index) => {
        // const updatedAddresses = [...addresses];
        // updatedAddresses.splice(index, 1);
        setAddresses({});
    };

    const handleClose = () => {
        setOpen(false);
    };

    const getRows = (info) => {
        let updatedInfo = info.map((row, index) => {
            return {
                type: "addresses",
                id: index,
                street_address1: row.primary_street_address1,
                street_address2: row.primary_street_address2,
                city: row.primary_city,
                state: row.primary_state,
                // country: row.primary_country,
                postal_code: row.primary_postal_code,
            };
        });
        return updatedInfo;
    };

    const dataTableData = {
        columns: [
            { Header: "Street Address1", accessor: "street_address1", width: "20%" },
            { Header: "Street Address2", accessor: "street_address2", width: "20%" },
            { Header: "City", accessor: "city", width: "10%" },
            { Header: "State", accessor: "state", width: "10%" },
            // { Header: "Country", accessor: "country", width: "10%" },
            { Header: "Postal Code", accessor: "postal_code", width: "10%" },
            {
                Header: "actions",
                disableSortBy: true,
                accessor: "",
                Cell: (info) => {
                    return (
                        <MDBox display="flex" alignItems="center">
                            {(
                                <Tooltip title="Edit Address">
                                    <IconButton onClick={() => editAddress(info.cell.row.original.id)}>
                                        <MDTypography><EditIcon /></MDTypography>
                                    </IconButton>
                                </Tooltip>
                            )}
                            {(
                                <Tooltip title="Delete Address">
                                    <IconButton onClick={() => removeAddress(info.cell.row.original.id)}>
                                        <MDTypography><DeleteIcon /></MDTypography>
                                    </IconButton>
                                </Tooltip>
                            )}
                        </MDBox>
                    );
                },
            }
        ],

        rows: getRows([newAddress]),
    };

    return (
        <Card sx={{ marginTop: '1rem' }}>
            {/* <ToastContainer /> */}
            <MDBox display="flex" flexDirection="column" px={3} my={2}>
                <MDBox display="flex" flexDirection="column" style={{ marginTop: "1rem" }}>
                    <MDBox
                        display="flex"
                    >
                        <MDTypography variant="h5" fontWeight="bold">
                            Addresses
                        </MDTypography>
                        {
                            !addresses?.primary_street_address1 &&
                            <MDButton variant="gradient" color="dark" size="small" style={{ marginLeft: "1rem" }} onClick={handleOpen}>+ Add Address</MDButton>
                        }
                    </MDBox>

                    <Modal
                        open={open}
                        onClose={handleClose}
                        aria-labelledby="modal-title"
                        aria-describedby="modal-description"
                    >
                        <Card
                            sx={{
                                position: 'absolute',
                                top: '50%',
                                left: '50%',
                                transform: 'translate(-50%, -50%)',
                                width: '80%', // Set the desired width here
                                backgroundColor: 'white',
                                border: '2px solid #000',
                                boxShadow: 24,
                                // p: 4,
                            }}
                        >
                            <CardContent>
                                <MDTypography>New Address</MDTypography>
                                <div className="places-autocomplete-container">
                                    <GooglePlacesAutocomplete
                                        apiKey={process.env.REACT_APP_MAP_API_KEY}
                                        onSelect={handleSelect}
                                    />

                                    <style>{`
                              .places-autocomplete-container {
                                position: relative;
                              }

                              .google-places-autocomplete__input {
                                width: 100%;
                                padding: 8px;
                                border: 1px solid #ccc;
                                border-radius: 4px;
                              }

                              .google-places-autocomplete__suggestions-container {
                                position: absolute;
                                top: calc(100% + 5px);
                                left: 0;
                                width: 100%;
                                background-color: #fff;
                                border: 1px solid #ccc;
                                border-radius: 4px;
                                box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
                                z-index: 1000;
                                max-height: 200px;
                                overflow-y: auto;
                              }

                              .google-places-autocomplete__suggestion {
                                padding: 8px 16px;
                                cursor: pointer;
                              }

                              .google-places-autocomplete__suggestion:hover {
                                background-color: #f0f0f0;
                              }

                              .google-places-autocomplete__suggestion--active {
                                background-color: #e0e0e0;
                              }
                        `}</style>
                                </div>
                                <MDBox sx={{
                                    maxHeight: '70vh', // Set max height to enable scrolling
                                    overflowY: 'auto',
                                    overflowX: 'hidden'
                                }}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={6}>
                                            <FormField
                                                required
                                                type="text"
                                                label="Street Address 1"
                                                value={newAddress.primary_street_address1}
                                                style={{ marginTop: "1rem" }}
                                                onChange={(e) =>
                                                    changeAddressHandler(indexAddr, "primary_street_address1", e.target.value)
                                                }
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <FormField
                                                type="text"
                                                label="Street Address 2"
                                                value={newAddress.primary_street_address2}
                                                style={{ marginTop: "1rem" }}
                                                onChange={(e) =>
                                                    changeAddressHandler(indexAddr, "primary_street_address2", e.target.value)
                                                }
                                            />
                                        </Grid>
                                    </Grid>
                                    <Grid container spacing={2}>
                                        <Grid item xs={6}>
                                            <FormField
                                                required
                                                type="text"
                                                label="City"
                                                value={newAddress.primary_city}
                                                style={{ marginTop: "1rem" }}
                                                onChange={(e) => changeAddressHandler(indexAddr, "primary_city", e.target.value)}
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <FormField
                                                required
                                                type="text"
                                                label="State"
                                                value={newAddress.primary_state}
                                                style={{ marginTop: "1rem" }}
                                                onChange={(e) => changeAddressHandler(indexAddr, "primary_state", e.target.value)}
                                            />
                                        </Grid>
                                    </Grid>
                                    <Grid container spacing={2}>
                                        <Grid item xs={6}>
                                            <FormField
                                                required
                                                type="text"
                                                label="Postal Code"
                                                value={newAddress.primary_postal_code}
                                                style={{ marginTop: "1rem" }}
                                                onChange={(e) => changeAddressHandler(indexAddr, "primary_postal_code", e.target.value)}
                                            />
                                        </Grid>
                                        {/* <Grid item xs={6}>
                                            <FormField
                                                required
                                                type="text"
                                                label="Country"
                                                value={newAddress.primary_country}
                                                style={{ marginTop: "1rem" }}
                                                onChange={(e) => changeAddressHandler(indexAddr, "primary_country", e.target.value)}
                                            />
                                        </Grid> */}
                                    </Grid>

                                </MDBox>
                                <MDBox ml="auto" mt={3} display="flex" justifyContent="flex-end">
                                    <MDButton variant="contained" color="secondary" onClick={handleClose}>
                                        Cancel
                                    </MDButton>
                                    <MDButton variant="contained" color="info" onClick={addressHandler} style={{ marginLeft: '10px' }}>
                                        Save
                                    </MDButton>
                                </MDBox>
                            </CardContent>
                        </Card>
                    </Modal>

                </MDBox>
                <MDBox>
                    {addresses?.primary_street_address1 ? (
                        <DataTable
                            table={dataTableData}
                            canSearch={true}
                        />
                    ) : <></>}
                </MDBox>
            </MDBox>
        </Card>
    );
};

export default CampaignAddress;
